type FooterColumnLink = {
    id: string
    name: string
    href: string
    isExternal: boolean
    ariaLabel?: string
    class_name?: string
}

type FooterColumn = {
    title: string
    links: Array<FooterColumnLink>
}

type FooterCopyrightText2 = {
    link1?: {
        name: string
        href: string
    }
    link2?: {
        name: string
        href: string
    }
}

type FooterCopyright = {
    text1: string
    text2?: FooterCopyrightText2
}

type FooterSocial = {
    id: string
    name: string
    href: string
}

type FooterSocials = {
    title: string
    list: Array<FooterSocial>
}

enum FooterSocialId {
    Instagram = 'instagram',
    Facebook = 'facebook',
    Linkedin = 'linkedin',
    Youtube = 'youtube',
    Pinterest = 'pinterest',
    Tiktok = 'tiktok',
    Spotify = 'spotify',
    WeChat = 'wechat',
    Weibo = 'weibo',
}

export {FooterColumn, FooterColumnLink, FooterCopyright, FooterCopyrightText2, FooterSocial, FooterSocials, FooterSocialId}
